
import { io } from 'socket.io-client';

const ioOptions = { transports: ['websocket'] };

export default class VTT {

    silenceInterval = 30000;
    silenceTimer = null; socket = null; context = null; globalStream = null; input = null; processor = null; consultation_id =null;
    model = ''; previous_text ='';
    editors = [];
    _triggers = {};

    constructor () {  
        if (VTT._instance) { return VTT._instance; }
        VTT._instance = this;
    }

    //events
    on ( event, callback ) {
        //we overwrite the previous attached events
        this._triggers[event] = callback;
    }

    trigger (event, params) {
        if (this._triggers[event]) {
            this._triggers[event](params);
        }
    }
    //events

    connect () { this.socket = io(process.env.VUE_APP_VTT_SERVER_URL, ioOptions ); }

    isConnected () { return this.socket.connected; }

    async startStream (consultation_id) {
        try {
            this.startSilenceListener();
            this.consultation_id = consultation_id;
            this.socket.emit('startGCloudStream', {consultation_id: consultation_id});
            let audioContext = window.AudioContext || window.webkitAudioContext;
            this.context = new audioContext({ latencyHint: "interactive" });
            
            await this.context.audioWorklet.addModule('/VTTProcessor.js');
            this.context.resume();
  
            this.globalStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
            this.input = this.context.createMediaStreamSource(this.globalStream);

            this.processor = new window.AudioWorkletNode(this.context, "recorder.worklet");
            this.processor.connect(this.context.destination);
            this.context.resume();

            // Connect and get processed audio
            this.input.connect(this.processor);
            this.processor.port.onmessage = (e) => {
                this.socket.emit("binaryData", e.data);
            };

            return true;
  
        } catch (error) {

            console.log('Error: ', error);
            return false;

        }
    }

    stopStream () {
        
        let self = this;
        if (this.globalStream != null) {
            let track = this.globalStream.getTracks()[0];
            track.stop();
        }

        if (this.input != null) {
            this.input.disconnect(this.processor);
        }

        if (this.processor != null) {
            this.processor.disconnect(this.context.destination);
        }
        
        if (this.context != null) {
            this.context.close().then( () => {
                self.input = null;
                self.processor = null;
                self.context = null;
                self.fn = null;
            });
        }
        
        this.socket.emit('endGCloudStream', '');
        this.trigger('streamStop', {last_text: this.previous_text, model: this.getModel()});
        this.clearSilenceListener();
        this.model = '';
    }

    async startSpeechListener (fn, name) {
        this.socket.on("speechData", (response) => {
            console.log('sssssss');
            this.resetSilenceListener();
            if (fn != null && this.consultation_id == response.consultation_id) {
                let speech = response.data.results[0].alternatives[0].transcript;
                if (name == undefined) {
                    fn(speech);
                } else if (response.data.results[0] && response.data.results[0].isFinal){

                    console.log('Params: ', this.model);
                    console.log('Params: ', name);

                    if (this.model == name && this.previous_text != speech) {
                        this.previous_text = speech;
                        fn(speech);
                    }  
                }
            } else {
                console.log({
                    function: fn,
                    consultation_id: this.consultation_id
                })
            }     
        });
    }

    setModel (name) {
        this.model = name;
        this.resetSilenceListener();
    }

    getModel () {
        if (this.model == '') {
            if (this.editors.length == 1) {
                this.model = this.editors[0];
            }
        }
        console.log('vtt model: ', this.model);
        return this.model;
    }

    //special case for Vue editor
    bindEditor (editorModel) {
        this.editors.push(editorModel);
    }

    unbindEditor (editorModel) {
        let index = this.editors.indexOf(editorModel);
        if (index >= 0) {
            this.editors.splice(index, 1);
        }
    }
    //special case for Vue editor

    checkErrors () {
        if (!this.socket.connected) { return 'Voice to Text offline. Please try again'; }
        if (this.getModel() == '') { return 'No detected input field. Kindly place the cursor in a text field.'; }
        return false;
    }

    startSilenceListener () {
        let self = this;
        this.silenceTimer = setTimeout( function() {
            self.stopStream();
        }, this.silenceInterval);
    }

    resetSilenceListener () {
        this.clearSilenceListener();
        this.startSilenceListener();
    }

    clearSilenceListener () {
        clearTimeout(this.silenceTimer);
    }
}